import { transitionDuration, transitionFunction } from 'globals/styles';

const styles = {
  button: {
    backgroundColor: '#f9fdfe',
    border: '1px solid #52aaff',
    color: '#52aaff',
    display: 'inline-block',
    cursor: 'pointer',
    borderRadius: '3px',
    fontSize: '1rem',
    fontWeight: '500',
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: 'normal',
    lineHeight: '28px',
    height: '30px',
    padding: '0 10px',
    transition: `all ${transitionDuration} ${transitionFunction}`,
    whiteSpace: 'nowrap',
    margin: '5px',
    outline: '0',
    ':disabled': {
      opacity: '.5',
      cursor: 'not-allowed',
    },
    ':hover': {
      transition: `all ${transitionDuration} ${transitionFunction}`,
      backgroundColor: '#f0fafd',
      boxShadow: '0 2px 7px rgba(0, 0, 0, 0.1)',
    },
    ':hover:disabled': {
      cursor: 'default !important',
      backgroundColor: '#f9fdfe',
      boxShadow: 'none',
    },
  },
  innerText: {
    fontSize: '0.875rem',
    textTransform: 'capitalize',
  },
  icon: {
    marginRight: '4px',
    position: 'relative',
    top: '2px',
    width: '1rem',
    display: 'inline',
  },
};

export default styles;
